import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import NRRiseAiIcon from '../../NRIcons/NRRiseAiIcon';
import NRRiseAiChatDrawer from './NRRiseAiChatDrawer';
import { useTheme } from '@mui/material/styles';

function NRRiseAiChatButton() {
  const theme = useTheme();
  const [openDrawer, setOpenDrawer] = useState(false);

  const handleOpen = () => {
    setOpenDrawer(true);
  };

  const handleClose = () => {
    setOpenDrawer(false);
  };

  return (
    <>
      <Box sx={{ ml: theme.spacing(2), alignSelf: 'center', mt: theme.spacing(-1.25) }}>
        <Button
          sx={{
            textTransform: 'unset',
            fontWeight: 600,
            whiteSpace: 'nowrap',
            borderColor: theme.palette.riseAiPurple,
            color: theme.palette.riseAiPurple,
            '&:hover': {
              borderColor: theme.palette.riseAiPurple,
              backgroundColor: `${theme.palette.riseAiPurple}10`
            }
          }}
          disableElevation
          variant="outlined"
          startIcon={<NRRiseAiIcon height="20" width="20" color={theme.palette.riseAiPurple} />}
          onClick={handleOpen}
        >
          Chat with RiseAI
        </Button>
      </Box>
      <NRRiseAiChatDrawer open={openDrawer} onClose={handleClose} />
    </>
  );
}

export default NRRiseAiChatButton;
